import { createMDAuthManager } from '@funtech-int/yango-shared';

import { clientConfig } from '@/config/client';

interface AuthManagerParams {
    lang: string;
}

export function createAuthManager(params: AuthManagerParams) {
    return createMDAuthManager({
        ssoHost: clientConfig.authConfig.ssoHost,
        passportHost: clientConfig.authConfig.passportUrl,
        origin: clientConfig.authConfig.origin,
        lang: params.lang,
    });
}
